<template>
    <transition name="mask">
        <div v-show="myActive" class="modal-layer">
            <div class="modal-mask" @click="closeMask"></div>
            <transition name="modal">
                <div
                    v-if="myActive"
                    id="modalB"
                    class="modal modal-bottom"
                >
                    <div class="modal-header">
                        <div class="coupon-name">
                            <p>美食优惠券</p>
                            <div class="modal-close-btn" @click="closeMask">
                                <i class="modal-close-btn-i"></i>
                            </div>
                        </div>
                    </div>
                    <div class="modal-content">
                        <div class="modal-wrap">
                            <img
                                v-if="!hideFoodBanner"
                                :src="icon_img"
                                class="head-pic"
                                alt=""
                                @click="toMainHall"
                            >
                            <div
                                v-for="(item, index) in coupon_list"
                                :key="index + 'coupon'"
                                class="voucher"
                            >
                                <div class="voucher-left">
                                    <div class="voucher-left-price">
                                        ¥<span>{{ item.discount_amount }}</span>
                                    </div>
                                    <div class="voucher-left-direction">
                                        {{ item.use_rule_str }}
                                    </div>
                                    <div
                                        class="voucher-left-usetime"
                                        :class="{'countDown-color': !useTimeScope(item)}"
                                    >
                                        {{ useTimeScope(item) || countDown }}
                                    </div>
                                </div>
                                <div
                                    class="voucher-right"
                                    :class="{
                                        is_opacity:
                                            item.code_status === 80 || item.code_status === 81,
                                    }"
                                    @click="closeMask"
                                >
                                    {{ is_useable(item) }}
                                </div>
                            </div>
                            <div v-if="coupon_list.length <= 0" class="no-ticket">券包空空，速去领券</div>
                        </div>
                    </div>
                    <div class="modal-footer"></div>
                </div>
            </transition>
        </div>
    </transition>
</template>
<script>
import server from '../../../service.js';
import {getParamsFromUrl} from '@baidu/map-fe-utils';
let top;
export default {
    name: 'modal',
    props: {
        popupData: {
            type: Object,
            default: () => {}
        }
    },
    created() {
        this.getDataHB();
    },
    data() {
        return {
            myActive: true,
            coupon_list: [],
            icon_img: '',
            countDown: '',
            currentTimer: null,
            hideFoodBanner: false
        };
    },
    mounted() {
        this.stopScroll(true); // 设置弹窗下页面不可滚动
        const {coupon_list = [], icon_img = '', icon_url = ''} = this.popupData || {};
        this.coupon_list = coupon_list || [];
        this.icon_img = icon_img || '';
        this.icon_url = icon_url || '';
    },
    methods: {
        // 倒计时
        down(time) {
            let djs = +new Date();
            let times = (time - djs) / 1000; // 剩余总秒数
            let hours = parseInt((times / 60 / 60) % 24, 10); // 小时
            let m = parseInt((times / 60) % 60, 10); // 分钟
            let s = parseInt(times % 60, 10); // 秒
            hours = hours < 10 ? '0' + hours : hours;
            m = m < 10 ? '0' + m : m;
            s = s < 10 ? '0' + s : s;
            return hours + ':' + m + ':' + s;
        },
        // 使用时间范围
        useTimeScope(data = {}) {
            if (
                data
                && data.use_time_end
                && data.use_time_start
                && data.current_time
            ) {
                let isDelay = data.current_time - data.use_time_end;
                let isStart = data.current_time - data.use_time_start;
                // 未开始、已过期、已使用 返回使用时间范围
                if (isStart < 0 || data.code_status === 81 || data.code_status === 80) {
                    return data.use_time_str;
                }
                // 可使用时间范围内
                if (data.use_time_start < data.current_time < data.use_time_end) {
                    // 小于一天：倒计时 时分秒
                    if (Math.abs(isDelay) < 86400) {
                        this.currentTimer = setInterval(() => {
                            this.countDown = `${this.down(data.use_time_end * 1000)}  后过期`;
                        }, 1000);
                        this.$once('hook:beforeDestroy', () => {
                            clearInterval(this.currentTimer);
                            this.currentTimer = null;
                        });
                    }
                    else {
                        // 大于一天：倒计时天数
                        return `${parseInt(Math.abs(isDelay) / 60 / 60 / 24, 10)}  天后过期`;
                    }
                }
                return '';
            }
            return '';
        },
        /**
         * 阻止页面滚动，用于弹窗开启
         */
        stopScroll(isFixed) {
            const bodyEl = document.body;
            if (isFixed) {
                top = window.scrollY;
                bodyEl.style.position = 'fixed';
                bodyEl.style.top = -top + 'px';
            }
            else {
                bodyEl.style.position = '';
                bodyEl.style.top = '';

                window.scrollTo(0, top); // 回到原先的top
            }
        },
        getDataHB() {
            // 测试地址
            // let url = `http://map-qianmo-new-130015.bcc-szth.baidu.com:8181/cater/coupon/getcouponpackagelist?qt=coupon_package_list`;
            // 线上地址
            server('GetCoupons', {
                sence: 'activity',
                activity_id: getParamsFromUrl().activity_id,
                app_id: 20230206
            })
                .then(res => {
                    const {
                        data: {coupon_list = [], icon_img = '', icon_url = ''}
                    } = res || {};
                    this.coupon_list = coupon_list || [];
                    this.icon_img = icon_img || '';
                    this.icon_url = icon_url || '';
                });
        },
        toMainHall() {
            // const url = `baidumap://map/cost_share?pageflag=4&popRoot=no&url=${encodeURIComponent(
            //     'https://map.baidu.com/zt/y2022/guoqingFoodActivities/index.html?fr=transDia'
            // )}`;
            const url = 'baidumap://map/cost_share?navigationStatus=2&popRoot=no&hiddenTitle=1&url=https%3A%2F%2Fscenes.map.baidu.com%2Fstatic%2Fsubpages%2Ffood-static%2Ffood-static.html%3Factivity_id%3D03hp07h6000eqg23ec08%26fr%3Dqingrenjie';
            window.location.href = url;
            this.closeMask();
        },
        is_useable(item) {
            const {code_status = ''} = item || {};
            if (code_status === 80) {
                return '已使用';
            }
            else if (code_status === 81) {
                return '已过期';
            }
            else if (code_status === 0) {
                return '去使用';
            }
        },
        closeMask() {
            this.myActive = !this.myActive;
            this.$emit('close');
            // const api = 'baidumap://map/floatWeb?action=close';
            // requestBaiduMapApi(api);
        }
    },
    destroyed() {
        this.stopScroll(false);
    }
};
</script>

<style lang="scss" scoped>

.modal-layer {
    display: block;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    overflow: hidden;
    z-index: 1000;

    .modal-mask {
        transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);
        filter: blur(10%);
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.5);
    }

    .modal {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        max-height: 124.8vw;
        background-color: #fff;
    }

    .modal-bottom {
        border-top-right-radius: 13px;
        border-top-left-radius: 13px;
    }
    .modal-header {
        overflow: hidden;
        border-top-right-radius: 13px;
        border-top-left-radius: 13px;

        .coupon-name {
            position: relative;
            display: -webkit-box;
            -webkit-box-align: center;
            background-color: #fff;
            line-height: 175 / 3px;
            height: 175 / 3px;
            width: 100%;
            z-index: 99;

            p {
                max-width: 58%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin: 16px 0 16px 20px;
                font-family: PingFangSC-Semibold;
                font-size: 20px;
                color: #11141a;
                line-height: 1;
                letter-spacing: 0;
                font-weight: 600;
            }
            .modal-close-btn {
                position: absolute;
                right: 0;
                display: -webkit-box;
                -webkit-box-pack: center;
                -webkit-box-align: center;
                width: 50px;
                height: 175 / 3px;
            }

            i {
                display: inline-block;
                background: url("https://mapcarowner-gz.cdn.bcebos.com/default/05b606a340b8a0364d3d32583e21df4e.png")
                center center no-repeat;
                width: 18px;
                height: 18px;
                background-size: cover;
                color: #666;
                -webkit-transform: translateY(2px);
                transform: translateY(2px);
            }
        }
    }

    .modal-content {
        overflow: auto;
        max-height: 73.33333vw;
        &::-webkit-scrollbar{
            display: none;
        }

        .modal-wrap {
            margin: 0 20px;
            border-radius: 16px;
            background-color: #fff;
            .head-pic {
                width: 100%;
                border-radius: 8px;
                margin-bottom: 10px;
            }
            .voucher {
                background: url(https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/voucher_bgc%403x.png)
                center center no-repeat;
                background-size: 100% 100%;
                position: relative;
                + .voucher {
                    margin-top: 10px;
                }

                .voucher-left {
                    display: flex;
                    text-align: left;
                    flex-direction: column;
                    padding: 8px 0 9px 13px;

                    .voucher-left-price {
                        margin-left: 1px;
                        font-family: PingFangSC-Semibold;
                        font-size: 12px;
                        color: #ff4d4d;
                        letter-spacing: 0;
                        font-weight: 600;
                        line-height: 1;
                        span {
                            font-size: 20px;
                        }
                    }

                    .voucher-left-direction {
                        margin: 6px 0 19px;
                        font-family: PingFangSC-Medium;
                        font-size: 11px;
                        color: #333333;
                        letter-spacing: 0;
                        font-weight: 500;
                        line-height: 1;
                    }

                    .voucher-left-usetime {
                        font-family: PingFangSC-Regular;
                        font-size: 10px;
                        color: #5c6473;
                        letter-spacing: 0;
                        font-weight: 400;
                        line-height: 1;
                    }
                    .countDown-color {
                        color: #ff4d4d;
                    }
                }
                .voucher-right {
                    position: absolute;
                    top: 13px;
                    right: 13px;
                    width: 72px;
                    background-image: linear-gradient(270deg, #ff7375 0%, #ff4d4d 100%);
                    box-shadow: 0 4px 8px 0 rgba(255, 77, 77, 0.32);
                    border-radius: 13px;
                    font-family: PingFangSC-Medium;
                    font-size: 12px;
                    color: #ffffff;
                    letter-spacing: 0;
                    text-align: center;
                    font-weight: 500;
                    padding: 7px 0;
                    line-height: 1;
                }
            }

            .no-ticket {
                color: #ccc;
                font-size: 13px;
                text-align: center;
            }
        }
    }
}
.is_opacity {
    opacity: 0.5;
}
.modal-footer {
    position: relative;
    z-index: 16;
    width: 100%;
    height: 50px;
}





.modal-enter-active,
.modal-leave-active {
    transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);
}

.modal-enter,
.modal-leave-active {
    transform: scale(1.1);
    opacity: 1;
}

.mask-leave-active {
    transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);
    transition-delay: 0.2s;
}

.modal-top {
    bottom: 0;
    border-radius: 0;
    width: 100%;
    margin: 0;
    max-width: none;
}

.modal-bottom.modal-enter,
.modal-top.modal-enter,
.modal-bottom.modal-leave-active,
.modal-top.modal-leave-active {
    transform: translateY(100%);
    opacity: 1;
}

.modal-top {
    top: 0;
    bottom: initial !important;
}

.modal-top.modal-enter,
.modal-top.modal-leave-active {
    transform: translateY(-100%);
    opacity: 1;
}

.modal.pi-cancel-o:before {
    content: 'X';
    position: absolute;
    padding: 8rem/75;
    top: 10rem/75;
    right: 20rem/75;
    color: #666;
}

.modal-open {
    display: block;
}

.modal-close {
    display: none;
}
</style>